import { render, staticRenderFns } from "./saleReturnbatchNumber.vue?vue&type=template&id=f2d10eb8"
import script from "./saleReturnbatchNumber.vue?vue&type=script&lang=js"
export * from "./saleReturnbatchNumber.vue?vue&type=script&lang=js"
import style0 from "./saleReturnbatchNumber.vue?vue&type=style&index=0&id=f2d10eb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports